import ReactMarkdown from 'react-markdown';

interface MarkdownRendererProps {
  content: string;
}

export function MarkdownRenderer({ content }: MarkdownRendererProps) {
  return (
    <div className="ai-analysis-content">
      <ReactMarkdown
        components={{
          h1: ({ children }) => (
            <h1 className="text-2xl font-bold text-chocolate-900 mt-8 mb-4 pb-3 border-b border-cream-300 first:mt-0">{children}</h1>
          ),
          h2: ({ children }) => (
            <h2 className="text-xl font-bold text-chocolate-800 mt-8 mb-3 pb-2 border-b border-cream-200">{children}</h2>
          ),
          h3: ({ children }) => (
            <h3 className="text-lg font-semibold text-chocolate-800 mt-6 mb-2">{children}</h3>
          ),
          h4: ({ children }) => (
            <h4 className="text-base font-semibold text-chocolate-700 mt-4 mb-2">{children}</h4>
          ),
          p: ({ children }) => (
            <p className="text-chocolate-700 leading-[1.75] mb-4 text-[15px]">{children}</p>
          ),
          ul: ({ children }) => (
            <ul className="space-y-2 mb-5 ml-1">{children}</ul>
          ),
          ol: ({ children }) => (
            <ol className="space-y-2 mb-5 ml-5 list-decimal">{children}</ol>
          ),
          li: ({ children }) => (
            <li className="text-chocolate-700 text-[15px] leading-[1.75] pl-1">{children}</li>
          ),
          strong: ({ children }) => (
            <strong className="font-semibold text-chocolate-900">{children}</strong>
          ),
          em: ({ children }) => (
            <em className="text-chocolate-600 italic">{children}</em>
          ),
          blockquote: ({ children }) => (
            <blockquote className="border-l-4 border-sage-300 bg-sage-50/50 pl-4 py-3 pr-4 my-4 rounded-r-lg">
              {children}
            </blockquote>
          ),
          hr: () => (
            <hr className="my-8 border-cream-300" />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
